// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"1cdeff1a","256":"6f9bfbf2","481":"834dcba2","736":"13d2a106","919":"13d2a106","940":"fcdc139b"}[chunkId] + ".chunk.css";
};